import { supabase } from "@/integrations/supabase/client";

/** Permanently delete the signed-in user's account and all their data.
 *  Backed by the `delete-account` edge function, which identifies the user
 *  from their JWT (you can only ever delete yourself). The caller should sign
 *  out afterward. */
export async function deleteAccount(): Promise<void> {
  const { data, error } = await supabase.functions.invoke("delete-account");
  if (error) throw error;
  if (data && (data as { error?: string }).error) {
    throw new Error((data as { error: string }).error);
  }
}
